import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=490eddf9&"
import script from "./ImageUpload.vue?vue&type=script&lang=js&"
export * from "./ImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490eddf9')) {
      api.createRecord('490eddf9', component.options)
    } else {
      api.reload('490eddf9', component.options)
    }
    module.hot.accept("./ImageUpload.vue?vue&type=template&id=490eddf9&", function () {
      api.rerender('490eddf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/components/ImageUpload.vue"
export default component.exports